module.exports = __webpack_public_path__ + "static/media/task-scheduler.4bcf874b.png";